export const COMMON_PREFIX = 'cuvva.common';
